<template>
    <div class="component">
        <b-card class="">
            <b-row>
                <b-col cols="12" md="4">
                    <b-row>
                        <b-col cols="6" md="3" class="mr-2">
                            <b-avatar
                                variant="info"
                                :text="getNameInitials"
                                size="10rem"
                            ></b-avatar>
                        </b-col>

                        <b-col class="mr-2" cols="6" md="8">
                            <b-row>
                                <h4
                                    v-if="companyData.name"
                                    class="text-truncate d-block"
                                >
                                    {{ companyData.name }}
                                </h4>
                            </b-row>

                            <b-row class="mt-3">
                                <b-col>
                                    <b-row>
                                        <p class="font-medium-2">
                                            {{
                                                $t("modules.people.profile") +
                                                " " +
                                                $t("common.status")
                                            }}
                                        </p>
                                    </b-row>

                                    <b-row class="">
                                        <b-badge
                                            v-if="companyData.status"
                                            :variant="
                                                statusVariant(
                                                    companyData.status
                                                        .description
                                                )
                                            "
                                            class="mr-1"
                                            style="height: 1.5rem"
                                        >
                                            {{ companyData.status.description }}
                                        </b-badge>

                                        <p
                                            v-if="companyData.id"
                                            class="text-truncate"
                                        >
                                            ID: {{ companyData.id }}
                                        </p>
                                    </b-row>

                                    <b-row>
                                        <p v-if="companyData.editor">
                                            {{
                                                $t(
                                                    "common.crud.lastUpdatedAtBy",
                                                    {
                                                        time: $d(
                                                            new Date(
                                                                companyData.updatedAt
                                                            ),
                                                            "dateTime"
                                                        ),
                                                        user:
                                                            companyData.editor
                                                                .name,
                                                    }
                                                )
                                            }}
                                        </p>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row class="mt-4">
                        <b-col>
                            <b-button
                                v-if="$can('edit companies')"
                                class="mr-1"
                                variant="primary"
                                style="background-color: #519bd6"
                                @click="
                                    $emit(
                                        'openEditResourceTab',
                                        'companiesEditTabForm'
                                    )
                                "
                            >
                                {{
                                    $t("common.crud.editResource", {
                                        resource: $tc(
                                            "modules.companies.description",
                                            1
                                        ),
                                    })
                                }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="12" md="4">
                    <formulateForm v-model="formData" name="headerForm">
                        <b-row class="d-block mb-1">
                            <div>
                                <feather-icon
                                    icon="StarIcon"
                                    size="18"
                                ></feather-icon>
                                <span class="ml-1"
                                    ><strong>{{
                                        $t("common.relationships")
                                    }}</strong></span
                                >
                            </div>
                            <div class="mt-1">
                                <formulateInput
                                    name="relationships"
                                    type="vue-select"
                                    multiple
                                    validation="optional"
                                    :options="
                                        relationshipsOptions.map((el) => ({
                                            value: el.id,
                                            label: el.description,
                                        }))
                                    "
                                    @input="handleRelationshipsUpdate"
                                    @update:input="
                                        formData.relationships = $event
                                    "
                                />
                            </div>
                        </b-row>

                        <b-row class="d-block">
                            <div>
                                <feather-icon
                                    icon="AwardIcon"
                                    size="18"
                                ></feather-icon>
                                <span class="ml-1"
                                    ><strong>{{
                                        $t("common.classifications")
                                    }}</strong></span
                                >
                            </div>
                            <div class="mt-1">
                                <formulateInput
                                    name="classifications"
                                    type="vue-select"
                                    multiple
                                    validation="optional"
                                    :options="
                                        classificationsOptions.map((el) => ({
                                            value: el.id,
                                            label: el.description,
                                        }))
                                    "
                                    @input="handleClassificationsUpdate"
                                    @update:input="
                                        formData.classifications = $event
                                    "
                                />
                            </div>
                        </b-row>
                    </formulateForm>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCol,
    BRow,
    VBToggle,
} from "bootstrap-vue"
import _ from "lodash"
import Api from "@/services/api"
import toastMessages from "@/views/components/utilis-spa/utilities/ToastMessages"

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BAvatar,
        BBadge,
        BButton,
    },
    directives: {
        "b-toggle": VBToggle,
    },
    props: {
        companyData: {
            required: true,
            type: Object,
        },
        classificationsOptions: {
            required: true,
            type: Array,
        },
        relationshipsOptions: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            collapseVisible: false,
            formData: {
                relationships: [],
                classifications: [],
            },
            enableClassificationRequest: false,
            enableRelationshipRequest: false,
        }
    },
    computed: {
        getNameInitials() {
            const split = this.companyData.name.split(" ", 2)
            if (split.length < 2) {
                return this.companyData.name[0] + this.companyData.name[1]
            }
            const first = split[0]
            const second = split[1]
            return first.charAt(0) + second.charAt(0)
        },

        statusVariant() {
            const statusColor = {
                Ativo: "light-success",
                Inativo: "light-danger",
            }

            return status => statusColor[status]
        },
    },
    created() {
        this.formData.classifications =
            (_.get(this.companyData, "classifications") &&
                this.companyData.classifications.map(el =>
                    el.id.toString()
                )) ||
            []

        this.formData.relationships =
            (_.get(this.companyData, "relations") &&
                this.companyData.relations.map(el => el.id.toString())) ||
            []
    },
    methods: {
        changeRoute(companyId) {
            this.$router.push({
                name: "edit-companies",
                params: { id: companyId },
            })
        },
        async handleClassificationsUpdate() {
            if (!this.enableClassificationRequest) {
                this.enableClassificationRequest = true
                return
            }
            try {
                const ids = this.formData.classifications.map(el => ({
                    id: el,
                }))
                await Api.one("companies", this.companyData.id)
                    .relationships("classifications")
                    .patch(ids)

                const values = this.classificationsOptions
                    .filter(el =>
                        this.formData.classifications.includes(el.id)
                    )
                    .map(el => el.description)

                this.$toast(
                    toastMessages.getSuccessSync(
                        "common.crud.successfulSyncronization",
                        "common.classifications",
                        values
                    )
                )
            } catch (e) {
                this.$toast(toastMessages.getUnexpectedError())
            }
        },
        async handleRelationshipsUpdate() {
            if (!this.enableRelationshipRequest) {
                this.enableRelationshipRequest = true
                return
            }
            try {
                const ids = this.formData.relationships.map(el => ({
                    id: el,
                }))
                await Api.one("companies", this.companyData.id)
                    .relationships("relations")
                    .patch(ids)

                const values = this.relationshipsOptions
                    .filter(el => this.formData.relationships.includes(el.id))
                    .map(el => el.description)

                this.$toast(
                    toastMessages.getSuccessSync(
                        "common.crud.successfulSyncronization",
                        "common.relationships",
                        values
                    )
                )
            } catch (e) {
                this.$toast(toastMessages.getUnexpectedError())
            }
        },
    },
}
</script>
